import { render, staticRenderFns } from "./RankResult.vue?vue&type=template&id=16b36935&"
import script from "./RankResult.vue?vue&type=script&lang=js&"
export * from "./RankResult.vue?vue&type=script&lang=js&"
import style0 from "./RankResult.vue?vue&type=style&index=0&id=16b36935&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports